/**
 * THE PUNCH LIST (Jeremy, 27 Oct 2026): every problem report from BOTH
 * applications, triaged in one list inside Fieldpath, replacing the two
 * spreadsheets (`Field-path-Problem-Concern punchlist-V28.xlsx`, F1-F93, and
 * `ResourceScheduler-Problem-Concern punchlist-V3.xlsx`, S1-S9) and their
 * version files. Its columns are the spreadsheets' columns.
 *
 * Seen by the people on the setting `punchlist.members` and nobody else;
 * "Jeremy's notes / decision" is written by `punchlist.deciders` alone.
 */
/** F for Fieldpath, S for the scheduler: the spreadsheets' numbering, continued. */
export function punchLabel(app, number) {
    return `${app === "fieldpath" ? "F" : "S"}${number}`;
}
/** The status automatic intake gives every new report: nobody has assessed it. */
export const PUNCH_NOT_LOOKED_AT = "New - not yet looked at";
/** Claude has investigated and written its response; Jeremy decides next. */
export const PUNCH_FOR_REVIEW = "New - for Jeremy's review";
//# sourceMappingURL=punch.js.map